import { Link } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Logo } from '@caratuva/ui';
import { APP_URL, DOCS_URL, GETPAID_URL } from '../lib/links.ts';
import { useSalesContact } from './SalesContact.tsx';

export function Footer() {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const { open: openSalesContact } = useSalesContact();
  // Static reference year — the SPA has no server clock and Date.now would make
  // the build non-deterministic; bump on the annual review.
  const year = 2026;

  const linkClass = 'text-sm text-[var(--color-navy-700)] hover:text-[var(--color-navy-950)]';

  return (
    <footer className="border-t border-[var(--color-beige-300)] bg-white">
      <div className="mx-auto grid max-w-5xl grid-cols-2 gap-8 px-4 py-12 sm:grid-cols-4">
        <div className="col-span-2 sm:col-span-2">
          <Logo size={24} />
          <p className="mt-3 max-w-xs text-sm text-[var(--color-navy-600)]">
            {t('footer.tagline')}
          </p>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-semibold text-[var(--color-navy-950)]">
            {t('footer.product')}
          </h3>
          <ul className="space-y-2">
            <li>
              <a href={GETPAID_URL} className={linkClass}>
                {t('footer.getPaid')}
              </a>
            </li>
            <li>
              <Link to="/pricing" className={linkClass}>
                {t('footer.pricing')}
              </Link>
            </li>
            <li>
              <Link to="/integrators" className={linkClass}>
                {t('footer.integrators')}
              </Link>
            </li>
            <li>
              <a href={DOCS_URL} className={linkClass}>
                {t('footer.docs')}
              </a>
            </li>
            <li>
              <a href={APP_URL} className={linkClass}>
                {t('footer.dashboard')}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-semibold text-[var(--color-navy-950)]">
            {t('footer.company')}
          </h3>
          <ul className="space-y-2">
            <li>
              <button type="button" onClick={openSalesContact} className={linkClass}>
                {t('footer.contact')}
              </button>
            </li>
            <li>
              <Link to="/privacy" className={linkClass}>
                {t('footer.privacy')}
              </Link>
            </li>
            <li>
              <Link to="/terms" className={linkClass}>
                {t('footer.terms')}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--color-beige-200)]">
        <div className="mx-auto max-w-5xl px-4 py-4 text-xs text-[var(--color-navy-500)]">
          {intl.formatMessage({ id: 'footer.rights' }, { year })}
        </div>
      </div>
    </footer>
  );
}
